import { TypographyProps, Typography, useTheme, Theme, SxProps } from "@mui/material";
import { FC, PropsWithChildren } from "react";


interface HeadingProps extends TypographyProps { sx?: SxProps<Theme> }

const Heading: FC<PropsWithChildren<HeadingProps>> = ({ sx = [], children }) => {
    const theme = useTheme();
    return (
        <Typography
            variant="secondaryFont"
            sx={[
                {
                    fontSize: 32,
                    fontWeight: 400,
                    textTransform: "capitalize",
                    lineHeight: '39px',
                    [theme.breakpoints.down('tablet')]: {
                        textAlign: "center"
                    }
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}>
            {children}
        </Typography>
    );
};

interface SubHeadingProps extends TypographyProps { sx?: SxProps<Theme> }

const SubHeading: FC<PropsWithChildren<SubHeadingProps>> = ({ sx = [], children, ...props }) => {
    const theme = useTheme();
    return (
        <Typography
            {...props}
            variant="primaryFont"
            sx={[
                {
                    fontSize: 24,
                    fontWeight: 400,
                    textTransform: "uppercase",
                    lineHeight: '29px',
                    [theme.breakpoints.down('tablet')]: {
                        textAlign: "center"
                    }
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}>
            {children}
        </Typography>
    );
};


export { Heading, SubHeading }